import tournoiInterne from "../../../assets/img/img-animations/04_tennis-raquettes_480X320.png";
import soireeClub from "../../../assets/img/img-animations/08_soireeClub_480x320.png";
import stage from "../../../assets/img/img-animations/16-stagesBanniere-480x320.png";
import parentsEnfants from "../../../assets/img/img-animations/10_parentsEnfants.jpg";
import tournoiOrange from "../../../assets/img/img-animations/11_tournoiJeunesOrange_480X320.jpg";
// import tournoiRouge from "../../../assets/img/img-animations/11_tournoiJeunesOrange_480X320.jpg";
import tournoiVert from "../../../assets/img/img-animations/12_tournoiJeunesVert_480X320.jpg";

const tabActivitesJeunes = [
  {
    id: 0,
    image: parentsEnfants,
    animation: "Parents - Enfants",
    desc: "Rencontre parents enfants",
    dateDebut: "2026-10-10",
    dateFin: "2026-10-10",
    lieu: "Courts couverts 10h30 à 12h",
    link: "/animations",
  },
  {
    id: 1,
    image: tournoiInterne,
    animation: "Plateau Rouge",
    desc: "Tournoi balles rouges",
    dateDebut: "2026-11-07",
    dateFin: "2026-11-07",
    lieu: "Courts couverts de 10h à 13h",
    link: "/competitions/jtournoi",
  },
  {
    id: 2,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "8/10 ans vert et 15/18 ans",
    dateDebut: "2026-11-14",
    dateFin: "2026-11-14",
    lieu: "Courts couverts",
    link: "/competitions/jchampt",
  },
  {
    id: 3,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "11/12 ans et 13/14 ans",
    dateDebut: "2026-11-21",
    dateFin: "2026-11-21",
    lieu: "Courts couverts",
    link: "/competitions/jchampt",
  },
  {
    id: 4,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "8/10 ans vert et 15/18 ans",
    dateDebut: "2026-11-28",
    dateFin: "2026-11-28",
    lieu: "Courts couverts",
    link: "/competitions/jchampt",
  },
  {
    id: 5,
    image: parentsEnfants,
    animation: "Parents - Enfants",
    desc: "Rencontre parents enfants",
    dateDebut: "2026-12-05",
    dateFin: "2026-12-05",
    lieu: "Courts couverts 10h30 à 12h",
    link: "/animations",
  },
  {
    id: 6,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "11/12 ans et 13/14 ans",
    dateDebut: "2026-12-05",
    dateFin: "2026-12-05",
    lieu: "Déplacement",
    link: "/competitions/jchampt",
  },
  {
    id: 7,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "8/10 ans vert et 15/18 ans",
    dateDebut: "2026-12-12",
    dateFin: "2026-12-12",
    lieu: "Courts couverts",
    link: "/competitions/jchampt",
  },
  {
    id: 8,
    image: tournoiVert,
    animation: "Championnat par équipes",
    desc: "11/12 ans et 13/14 ans",
    dateDebut: "2026-12-19",
    dateFin: "2026-12-19",
    lieu: "Déplacement",
    link: "/competitions/jchampt",
  },
  {
    id: 9,
    image: parentsEnfants,
    animation: "Parents - Enfants",
    desc: "Rencontre parents enfants",
    dateDebut: "2027-02-05",
    dateFin: "2027-02-05",
    lieu: "Courts couverts 10h30 à 12h",
    link: "/animations",
  },
  {
    id: 10,
    image: stage,
    animation: "Stages Hiver",
    desc: "Semaine de stage sur une demi-journée",
    dateDebut: "2027-02-15",
    dateFin: "2027-02-19",
    lieu: "Courts couverts",
    link: "/enseignement#stageTennis",
  },
  // {
  //   id: 5,
  //   image: tournoiInterne,
  //   animation: "Tournoi interne",
  //   desc: "Tournoi interne balles rouges - groupes du mercredi 10h et jeudi 16h45",
  //   dateDebut: "2024-04-06",
  //   dateFin: "2024-04-06",
  //   lieu: "Courts couverts de 10h à 13h",
  //   link: "/competitions",
  // },
  {
    id: 11,
    image: parentsEnfants,
    animation: "Parents - Enfants",
    desc: "Rencontres parents enfants",
    dateDebut: "2027-04-03",
    dateFin: "2027-04-03",
    lieu: "Courts couverts de 10h30 à 12h",
    link: "/animations",
  },
  {
    id: 12,
    image: tournoiOrange,
    animation: "Championnat par équipes",
    desc: "7/10 ans orange",
    dateDebut: "2027-04-03",
    dateFin: "2027-04-03",
    lieu: "Déplacement",
    link: "/competitions/jchampt",
  },
  {
    id: 13,
    image: tournoiOrange,
    animation: "Championnat par équipes",
    desc: "7/10 ans orange",
    dateDebut: "2027-03-13",
    dateFin: "2027-03-13",
    lieu: "Courts couverts",
    link: "/competitions/jchampt",
  },
  {
    id: 14,
    image: stage,
    animation: "Stages de printemps - Enfants",
    desc: "Semaine de stage pour enfants. Inscrivez-vous auprès de Fréd ...",
    dateDebut: "2027-04-12",
    dateFin: "2027-04-16",
    lieu: "Courts extérieurs et couverts",
    link: "/enseignement#stageTennis",
  },
  // {
  //   id: 9,
  //   image: tournoiInterne,
  //   animation: "Tournoi interne",
  //   desc: "Tournoi interne de fin de saison - Groupe compétition du mercredi et du samedi matin",
  //   dateDebut: "2024-06-14",
  //   dateFin: "2024-06-14",
  //   lieu: "Courts extérieurss de 17h à 20h",
  //   link: "/enseignements",
  // },
  {
    id: 15,
    image: soireeClub,
    animation: "Fête de l’école de Tennis",
    desc: "Jeux et démonstrations des jeunes de l'école de tennis ...",
    dateDebut: "2027-06-23",
    dateFin: "2027-06-23",
    lieu: "Courts extérieurs de 14h à 17h",
    link: "/animations/soireeclub",
  },
  {
    id: 16,
    image: stage,
    animation: "Stages d'été - Enfants",
    desc: "Première semaine de stage pour enfants. Inscrivez-vous auprès de Fréd ...",
    dateDebut: "2027-07-05",
    dateFin: "2027-07-09",
    lieu: "Courts extérieurs et couverts",
    link: "/enseignement#stageTennis",
  },
  {
    id: 17,
    image: stage,
    animation: "Stages d'été - Enfants",
    desc: "Deuxième semaine de stage pour enfants. Inscrivez-vous auprès de Fréd ...",
    dateDebut: "2027-07-12",
    dateFin: "2027-07-16",
    lieu: "Courts extérieurs et couverts",
    link: "/enseignement#stageTennis",
  },
  // {
  //   id: 13,
  //   image: stage,
  //   animation: "Stages d'été - Enfants",
  //   desc: "Troisième semaine de stage pour enfants. Inscrivez-vous auprès de Fréd ...",
  //   dateDebut: "2025-07-21",
  //   dateFin: "2025-07-25",
  //   lieu: "Courts extérieurs et couverts",
  //   link: "/enseignement#stageTennis",
  // },
  {
    id: 18,
    image: tournoiOrange,
    animation: "Tournoi jeunes",
    desc: "Tournoi Galaxie Orange",
    dateDebut: "2027-08-21",
    dateFin: "2027-08-21",
    lieu: "Courts extérieurs",
    link: "/competitions/jtournoi",
  },
  {
    id: 19,
    image: tournoiVert,
    animation: "Tournoi jeunes",
    desc: "Tournoi Galaxie Vert",
    dateDebut: "2027-08-22",
    dateFin: "2027-08-22",
    lieu: "Courts extérieurs",
    link: "/competitions/jtournoi",
  },
  // {
  //   id: 16,
  //   image: tournoiInterne,
  //   animation: "Tournoi jeunes",
  //   desc: "Galaxie tableaux 11/12-13/14-15/16 ans",
  //   dateDebut: "2026-08-24",
  //   dateFin: "2026-08-29",
  //   lieu: "Courts extérieurs",
  //   link: "/competitions",
  // },
];

export default tabActivitesJeunes;
